import { render, staticRenderFns } from "./DeleteBrandOfferPopup.vue?vue&type=template&id=2b3b0c6e&scoped=true&"
import script from "./DeleteBrandOfferPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteBrandOfferPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteBrandOfferPopup.vue?vue&type=style&index=0&id=2b3b0c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b0c6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b3b0c6e')) {
      api.createRecord('2b3b0c6e', component.options)
    } else {
      api.reload('2b3b0c6e', component.options)
    }
    module.hot.accept("./DeleteBrandOfferPopup.vue?vue&type=template&id=2b3b0c6e&scoped=true&", function () {
      api.rerender('2b3b0c6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/DeleteBrandOfferPopup.vue"
export default component.exports